import useLabels from "hooks/useLabels";

export const CitationDetailsLoading = () => {
  const [citationsLabel, influentialCitationsLabel] = useLabels(
    "screens.details.citations",
    "screens.details.influential-citations"
  );

  return (
    <div className="flex gap-4">
      <div>
        <div className="h-3 bg-bg-subtle w-[40px] rounded-full mb-2"></div>
        <p className="sm-normal text-fg-muted">{citationsLabel}</p>
      </div>
      <div>
        <div className="h-3 bg-bg-subtle w-[40px] rounded-full mb-2"></div>
        <p className="sm-normal text-fg-muted">
          {influentialCitationsLabel}
          &nbsp;
          <i className="icon-info" />
        </p>
      </div>
    </div>
  );
};
